<template>
  <div class="h5-head">
    <h3
      class="headTitle fix"
      style="max-width: 640px; background: rgba(255, 255, 255, 0.95); width: 100%; border-bottom: 1px solid rgba(255, 255, 255, 0.95); margin: 0px; padding: 0px; position: fixed; top: 0px; left: auto; z-index: 100;"
    >
      <a
        href="javascript:history.back();"
        class="back"
        style="position: absolute; height: 14px; width: 14px; left: 15px; top: 12px; border-top: 2px solid rgb(102, 102, 102); border-left: 2px solid rgb(102, 102, 102); transform: rotate(-45deg);"
      ></a>
      <p
        style="width: 70%; margin: 0px auto; height: 40px; line-height: 40px; font-family: &quot;microsoft yahei&quot;; color: rgb(51, 51, 51); text-align: center; font-size: 16px; font-weight: 400; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
      >919主会场</p>
      <a
        v-if="!isUcbank"
        @click="isShowFun"
        href="javascript:;"
        class="classfiy"
        style="background: url(&quot;//i0.ulecdn.com/ulewap/i/goodsDetail/icon-more.png&quot;) center center / 30px no-repeat; height: 40px; display: inline-block; width: 50px; margin-right: 0px; position: absolute; right: 0px; top: 0px;"
      ></a>
    </h3>
    <div
      v-show="isShowHead"
      class="classfiy_pop"
      style="background-color: rgba(0, 0, 0, 0.3); position: fixed; top: 0px; left: 0px; z-index: 999999; width: 100%; height: 100%; transform-origin: 0px 0px; opacity: 1; transform: scale(1, 1);"
    >
      <div
        @click="close"
        class="mask"
        style="z-index: 101; position: fixed; top: 0px; left: 0px; width: 100%; height: 100%;"
      ></div>
      <ul
        class="classfiy_nav"
        style="position: fixed; right: 0px; top: 40px; background: rgb(255, 255, 255); border-radius: 0px 0px 0px 5px; z-index: 102;"
      >
        <li
          class="homeLi"
          style="height: 40px; line-height: 40px; border-bottom: 1px solid rgb(204, 204, 204); width: 110px;"
        >
          <a
            href="//m.ule.com/"
            style="height: 40px; line-height: 40px; display: block; box-sizing: border-box; width: 100%; color: rgb(51, 51, 51); padding: 0px 0px 0px 10px; border-left: 2px solid rgb(255, 255, 255); font-size: 16px;"
          >
            <b
              style="width: 22px; height: 24px; background: url(&quot;//i0.ulecdn.com/ulewap/i/classfiyNav_icon.png&quot;) 0px 1px / 91px 46px no-repeat; margin: 0px 5px 0px 0px; display: inline-block; vertical-align: middle;"
            ></b>首页
          </a>
        </li>
        <li
          class="classfiyLi"
          style="height: 40px; line-height: 40px; border-bottom: 1px solid rgb(204, 204, 204); width: 110px;"
        >
          <a
            href="//m.ule.com/category/all.html"
            style="height: 40px; line-height: 40px; display: block; box-sizing: border-box; width: 100%; color: rgb(51, 51, 51); padding: 0px 0px 0px 10px; border-left: 2px solid rgb(255, 255, 255); font-size: 16px;"
          >
            <b
              style="width: 22px; height: 24px; background: url(&quot;//i0.ulecdn.com/ulewap/i/classfiyNav_icon.png&quot;) -24px 1px / 91px 46px no-repeat; margin: 0px 5px 0px 0px; display: inline-block; vertical-align: middle;"
            ></b>分类
          </a>
        </li>
        <li
          class="cartLi"
          style="height: 40px; line-height: 40px; border-bottom: 1px solid rgb(204, 204, 204); width: 110px;"
        >
          <a
            href="//m.ule.com/mitem/cart/list"
            style="height: 40px; line-height: 40px; display: block; box-sizing: border-box; width: 100%; color: rgb(51, 51, 51); padding: 0px 0px 0px 10px; border-left: 2px solid rgb(255, 255, 255); font-size: 16px;"
          >
            <b
              style="width: 22px; height: 24px; background: url(&quot;//i0.ulecdn.com/ulewap/i/classfiyNav_icon.png&quot;) -48px 1px / 91px 46px no-repeat; margin: 0px 5px 0px 0px; display: inline-block; vertical-align: middle;"
            ></b>购物车
          </a>
        </li>
        <li
          class="my_centerLi"
          style="height: 40px; line-height: 40px; width: 110px; border-bottom: none; border-radius: 0px 0px 0px 5px;"
        >
          <a
            href="//m.ule.com/user/center"
            style="height: 40px; line-height: 40px; display: block; box-sizing: border-box; width: 100%; color: rgb(51, 51, 51); padding: 0px 0px 0px 10px; border-left: 2px solid rgb(255, 255, 255); font-size: 16px;"
          >
            <b
              style="width: 22px; height: 24px; background: url(&quot;//i0.ulecdn.com/ulewap/i/classfiyNav_icon.png&quot;) -72px 1px / 91px 46px no-repeat; margin: 0px 5px 0px 0px; display: inline-block; vertical-align: middle;"
            ></b>我的邮乐
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>  

<script>
import Vue from "vue";
export default {
  props: ["isUcbank"],
  data() {
    return {
      isShowHead: false
    };
  },
  methods: {
    close() {
      this.isShowHead = false;
    },
    isShowFun() {
      this.isShowHead = this.isShowHead ? false : true;
    }
  },
  computed: {
    changeHeadTxt() {
      return this.$store.getters.changeHeadTxt;
    }
  }
};
</script>
<style lang="less" scoped>
/* 头部样式补充 */
h3.headTitle {
  z-index: 1000 !important;
}
.classfiy_nav li {
  list-style: none;
}
.btn-share {
  display: none;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 12;
}
.btn-share span {
  display: block;
  height: 44px;
  line-height: 44px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  background: #c7181d;
  border-radius: 22px;
  letter-spacing: 2px;
}
.btn-share span:before {
  content: "\e63b";
  font-family: "iconfont";
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/head.vue